import { useContext } from 'react';
import InnerFormSection from 'components/ui-components/forms/InnerFormSection';
import HookFormTextInput from 'components/cef_form/hook-form/HookFormTextInput';
import { HookFormContext } from 'components/cef_form/hook-form/providers/HookFormProvider';

const SoleTraderCompany = () => {
  const {
    watchedFields: { companyName },
  } = useContext(HookFormContext);

  return (
    <InnerFormSection title="Company Name">
      <HookFormTextInput
        className="mt-10"
        id="company_name"
        label="Full Trading Name"
        value={companyName}
        rules={{
          required: 'Please enter a full trading name',
        }}
      />
    </InnerFormSection>
  );
};

export default SoleTraderCompany;
